import { z } from 'zod';

/** Session behaviour every SDK must reproduce (BB-30); the scenarios fixture is the executable spec. */
export const SessionPolicyKind = z.enum(['auto', 'manual']);
export const DEFAULT_SESSION_TIMEOUT_MS = 10_000;
/** Server cap: longer reported durations are clamped and flagged `duration_clamped`. */
export const MAX_SESSION_DURATION_MS = 24 * 3_600_000;

export const SessionStep = z.strictObject({
  atMs: z.number().int().min(0),
  action: z.enum(['foreground', 'background', 'identify', 'logout', 'start', 'end', 'process_death', 'cold_start']),
  externalId: z.string().optional(),
});

export const ExpectedSessionOp = z.strictObject({
  type: z.enum(['session_start', 'session_end']),
  atMs: z.number().int().min(0),
  /** Scenario-local session name (`s1`, `s2`…); SDKs generate UUIDs. */
  sessionRef: z.string().min(1),
  durationMs: z.number().int().min(0).optional(),
});

export const SessionScenario = z.strictObject({
  name: z.string().min(1),
  description: z.string().optional(),
  policy: SessionPolicyKind,
  timeoutMs: z.number().int().positive(),
  steps: z.array(SessionStep).min(1),
  expectedOps: z.array(ExpectedSessionOp),
});

export const SessionScenarios = z.strictObject({
  schemaVersion: z.literal(1),
  description: z.string(),
  scenarios: z.array(SessionScenario).min(1),
});
export type SessionScenarios = z.infer<typeof SessionScenarios>;
